import { matchPath } from 'react-router-dom'

export const selectedRecord = (records, idField, record_id) =>
  records.find(record => String(record[idField] || record.id) === String(record_id))

export const matchWithRecordId = ({ location, base_url }) =>
  matchPath(location.pathname, {
    path: base_url + '/:record_id?',
  }) || { params: {} }



// WEBPACK FOOTER //
// ./src/ui/list/helpers.js